import { render, staticRenderFns } from "./EpiDatePicker.vue?vue&type=template&id=6a4e77c2"
import script from "./EpiDatePicker.vue?vue&type=script&lang=js"
export * from "./EpiDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports